import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "4",
  y: "3",
  width: "40",
  height: "8",
  rx: "3",
  stroke: "#666666",
  "stroke-width": "1.2",
  fill: "none"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "7",
  y: "5.5",
  width: "16",
  height: "3",
  rx: "1",
  fill: "#D6D6D6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "37.5",
  cy: "7",
  r: "2.2",
  stroke: "#999999",
  "stroke-width": "1",
  fill: "none"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("line", {
  x1: "39.2",
  y1: "8.7",
  x2: "40.5",
  y2: "10",
  stroke: "#999999",
  "stroke-width": "1",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<rect x=\"4\" y=\"15\" width=\"18\" height=\"14\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"6\" y=\"17\" width=\"14\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"6\" y=\"24\" width=\"10\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect><rect x=\"26\" y=\"15\" width=\"18\" height=\"14\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"28\" y=\"17\" width=\"14\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"28\" y=\"24\" width=\"10\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect><rect x=\"4\" y=\"32\" width=\"18\" height=\"14\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"6\" y=\"34\" width=\"14\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"6\" y=\"41\" width=\"10\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect><rect x=\"26\" y=\"32\" width=\"18\" height=\"14\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"28\" y=\"34\" width=\"14\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"28\" y=\"41\" width=\"10\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect>", 12)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<rect x=\"4\" y=\"15\" width=\"40\" height=\"9\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"6\" y=\"17\" width=\"10\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"18\" y=\"17.5\" width=\"14\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect><rect x=\"18\" y=\"20.5\" width=\"9\" height=\"1.5\" rx=\"0.5\" fill=\"#E0E0E0\"></rect><rect x=\"4\" y=\"26.5\" width=\"40\" height=\"9\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"6\" y=\"28.5\" width=\"10\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"18\" y=\"29\" width=\"14\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect><rect x=\"18\" y=\"32\" width=\"9\" height=\"1.5\" rx=\"0.5\" fill=\"#E0E0E0\"></rect><rect x=\"4\" y=\"38\" width=\"40\" height=\"9\" rx=\"2\" stroke=\"#666666\" stroke-width=\"1.2\" fill=\"none\"></rect><rect x=\"6\" y=\"40\" width=\"10\" height=\"5\" rx=\"1\" fill=\"#D6D6D6\"></rect><rect x=\"18\" y=\"40.5\" width=\"14\" height=\"2\" rx=\"0.5\" fill=\"#D6D6D6\"></rect><rect x=\"18\" y=\"43.5\" width=\"9\" height=\"1.5\" rx=\"0.5\" fill=\"#E0E0E0\"></rect>", 12)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    (_ctx.layout === 'horizontal')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_6
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_18
        ], 64))
  ]))
}